export var getStyle = function (el) { return el.style; };
